<template>
  <div>
    <WsDialog
      v-model="dialog"
      class="pb-2"
      ref="WsDialog"
      @close="close()"
      :title="`新增相關法規`"
    >
      <template v-slot:content>
        <div v-if="step===1 && dialog">
          <WsCRUD
            :modelName="'act'"
            :label="'法規'"
            :fields="actFields"
            :sortBy="sortBy"
            :showFields="actShowFields"
            :pageMode="true"
            :showExpand="false"
            :rowClickRead="false"
            :rowClickEmit="true"
            :isShowBtn="false"
            :liveSearching="true"
            :isMultiSelect="false"
            :showTitlebar="false"
            :hasSearchBtn="false"
            :customParams="_customActParams"
            noChangePage
            @rowClickInput="$_onActInput($event)"
          >
          </WsCRUD>
        </div>
        <div v-if="step===2 && dialog">
          <ValidationObserver ref="secStep">
            <WsInfo
              :label="'法規名稱'"
              :type="'text'"
              :value="fields.act.name"
            ></WsInfo>
            <WsState
              :label="'選擇修正發布日（版本）'"
              :type="'belongsTo'"
              parent="act"
              rules="required"
              :parentState="fields.act.id"
              modelName='act_version'
              :getText="$_actGetText"
              :originValue="_actOriginValue"
              :orderBy="fields.act.orderBy"
              :orderWay="fields.act.orderWay"
              v-model="fields.act.version_id"
            ></WsState>
          </ValidationObserver>
        </div>
        <div v-if="step===3 && dialog">
          <WsInfo
            :label="'法規名稱'"
            :type="'text'"
            :value="fields.act.name"
          ></WsInfo>
          <WsInfo
            :label="'選擇修正發布日（版本）'"
            :type="'date'"
            :value="fields.act.selectedActVersionData.announce_at"
          ></WsInfo>
          <WsState
            :label="'選擇法條'"
            :type="'radio'"
            :items="fields.actSelect.items"
            :defaultValue="fields.actSelect.defaultValue"
            v-model="fields.actSelect.radio"
          >
          </WsState>
          <WsCRUD
            v-show="fields.actSelect.radio===1"
            :modelName="'article_version'"
            :label="'法條'"
            :fields="articleFields"
            :sortBy="sortBy"
            :orderBy="articleOrderBy"
            :orderWay="articleOrderWay"
            :showFields="articleShowFields"
            :pageMode="true"
            :showExpand="false"
            :rowClickRead="false"
            :rowClickEmit="true"
            :isShowBtn="false"
            :liveSearching="true"
            :isMultiSelect="true"
            :showTitlebar="false"
            :hasSearchBtn="false"
            :hasMultiDeleteBtn="false"
            :customParams="_customArticleParams"
            noChangePage
            @input="$_onArticleInput($event)"
          >
          </WsCRUD>

        </div>
      </template>
      <template v-slot:rightActions>
        <div v-if="step===2">
          <WsBtn
            @click="$_onNextStep()"
            minWidth="100px"
            :loading="submitLoading"
            color="primary"
          >下一步</WsBtn>
        </div>
        <div v-if="step===3">
          <WsBtn
            @click="$_onSubmit()"
            minWidth="100px"
            :loading="submitLoading"
            color="primary"
          >送出</WsBtn>
        </div>
      </template>
      <template v-slot:leftActions>
        <div v-if="step !== 1">
          <WsBtn
            @click="$_onPreviousStep()"
            minWidth="100px"
            color="textSecondary"
            outlined
          >上一步</WsBtn>
        </div>
      </template>
    </WsDialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    submitLoading: false,
    dialog: false,
    step: 1,
    sortBy: "name",
    articleOrderBy: "no_number",
    articleOrderWay: "asc",
    actFields: {
      name: {
        label: "法規名稱",
        type: "text",
        width: "300px",
        readonly: true,
      },
    },
    articleFields: {
      updated_info: {
        type: "custom",
        label: "法條名稱",
        rules: "required",
        maxlength: 20,
        sm: 6,
        getValue: (item) => {
          if (!item) {
            return null;
          } else {
            return `${item.act_versions[0].name} - ${item.no_text}`;
          }
        },
      },
    },
    articleShowFields: ["updated_info"],
    actShowFields: ["name"],
    fields: {
      act: {
        name: "",
        modelData: {},
        id: null,
        version_id: null,
        actData: null,
        orderBy: "announce_at",
        orderWay: "desc",
        selectedActVersionData: {},
      },
      actSelect: {
        radio: 1,
        items: [
          {
            text: "綁定特定法條",
            value: 1,
          },
          {
            text: "綁定整部法規",
            value: 2,
          },
        ],
        defaultValue: 0,
      },
    },
    state: {
      act_versions: [],
      act_version_alls: [],
      article_versions: [],
    },
    modelData: null,
  }),
  methods: {
    $_handleDialogClose() {
      window.removeEventListener("keydown", this.$_keydownHandler);
    },
    $_keydownHandler(event) {
      if (event.metaKey && event.key == "Enter") {
        this.$_onSubmit();
      }
    },
    async $_onActInput($event) {
      try {
        const res = await this.$axios.get(`/act/${$event}`);
        this.fields.act.name = res.data.data.last_version.name;
        this.fields.act.id = $event;
        this.fields.act.actData = res.data.data.last_version;
        this.fields.act.version_id = res.data.data.last_version.id;
        this.$_onNextStep();
      } catch (error) {
        alert(error);
      }
    },
    $_onArticleInput($event) {
      this.state.article_versions = [...$event];
    },
    stopLoading() {
      this.submitLoading = false;
    },
    startLoading() {
      this.submitLoading = true;
    },
    async $_onSubmit() {
      try {
        const res = await this.$axios.get(
          `/act_version/${this.fields.act.version_id}`
        );
        if (this._radio == 2) {
          this.state.act_version_alls.push(res.data.data);
        }
        this.$emit("create-submit", this.state);
        this.close();
      } catch (error) {
        alert(error);
      }
    },
    $_onCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      window.removeEventListener("keydown", this.$_keydownHandler);
      this.reset();
    },
    reset() {
      for (let key in this.state) {
        this.state[key] = [];
      }
      this.step = 1;
      this.submitLoading = false;
    },
    open() {
      this.dialog = true;
      window.addEventListener("keydown", this.$_keydownHandler);
    },
    async $_onNextStep() {
      if (this.step === 2) {
        const isValidate = await this.$refs.secStep.validate();
        if (!isValidate) {
          return;
        }
        if (!this.fields.act.version_id) return;
        const verRes = await this.$axios.get(
          `/act_version/${this.fields.act.version_id}`
        );
        this.fields.act.selectedActVersionData = verRes.data.data;
      }
      this.step++;
    },
    $_onPreviousStep() {
      this.step--;
    },
    $_actGetText(item) {
      if (!item) {
        return null;
      } else {
        return this.$moment(item.announce_at).format("YYYY-MM-DD");
      }
    },
  },
  computed: {
    _customActParams() {
      let _customParams = {};
      _customParams.order_way = this.fields.act.orderWay;
      _customParams.order_by = this.fields.act.orderBy;
      if (this.conditions) {
        this.conditions.forEach((condition) => {
          if (
            condition.type &&
            condition.type == "array" &&
            condition.value &&
            Array.isArray(condition.value)
          ) {
            _customParams[condition.key] = condition.value.join();
          } else {
            _customParams[condition.key] = condition.value;
          }
        });
      }
      _customParams.is_active = 1;
      return _customParams;
    },
    _customArticleParams() {
      let _customParams = {};
      _customParams.order_way = this.articleOrderWay;
      _customParams.order_by = this.articleOrderBy;
      if (!this.fields.act.version_id) {
        return;
      } else {
        _customParams.act_versions = this.fields.act.version_id;
        return _customParams;
      }
    },
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
    _radio() {
      return this.fields.actSelect.radio;
    },
    _actOriginValue() {
      if (this.fields.act.actData) {
        return this.fields.act.actData;
      } else {
        return null;
      }
    },
  },
  props: {
    parentState: {
      default: null,
    },
    parent: {
      default: null,
    },
    requiredField: {
      type: String,
      default: "",
    },
    requiredFieldState: {
      default: null,
    },
    conditions: {
      type: Array,
    },
  },
  watch: {
    _radio: {
      handler() {
        this.state.article_versions = [];
      },
      deep: true,
    },
  },
};
</script>